// extracted by mini-css-extract-plugin
export default {"overflowHidden":"poster-editor-qr-content-panel-module__overflowHidden--Jcw6E","suggestionsDropdown":"poster-editor-qr-content-panel-module__suggestionsDropdown--WkStJ"};